var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SearchProductControl',{attrs:{"category-id":_vm.categoryId,"page-data-url":_vm.pageDataUrl,"page-data-result-callback":_vm.handlePageDataCallback,"search-result-callback":_vm.handleSearchResultCallback,"context-key":"category","with-results-breadcrumb":""},scopedSlots:_vm._u([{key:"navigation",fn:function(ref){
var activeMenuItem = ref.activeMenuItem;
var rootMenuItem = ref.rootMenuItem;
var menuItems = ref.menuItems;
return [_c('CategoryNavigation',{attrs:{"active-menu-item":activeMenuItem,"root-menu-item":rootMenuItem,"menu-items":menuItems}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }